import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import NavbarIcon from './NavbarIcon';
import './NotificationsDropdown.css';
import { notificationApi } from "../../api/NotificationApi";
import { NavigationUtils } from '../../util/NavigationUtils';

class NotificationsDropdown extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      unread: 0,
      messages: []
    };
  }

  componentDidMount () {
    this.fetchNotifications();
  }

  fetchNotifications = async () => {
    const status = await notificationApi.getStatus();
    this.setState({ unseen_count: status.unseen_count });

    const messages = await notificationApi.getList();
    this.setState({ messages: messages });
  };

  onClick = async () => {
    await notificationApi.clearUnseen();
    this.fetchNotifications();
  };

  render () {
    const { user, loggingOut } = this.props;
    const { unseen_count, messages } = this.state;

    return (
      <div className="d-inline-block col m-auto h-100 dropdown notifications-dropdown">
        <div
          id="nav-dropdown"
          data-toggle={ `${(user && !loggingOut) ? 'dropdown' : ''}` }
          aria-haspopup="true"
          aria-expanded="false">
          <div onClick={this.onClick} className={ `notif-menu-btn shimmy-on-hover ${(user && !loggingOut) ? 'clickable' : ''}` }>
            <NavbarIcon icon="notifications_active" tooltip="Notifications" />
            {unseen_count > 0 && <span className="badge">&nbsp;</span>}
          </div>
        </div>

        { user && (
          <div className="dropdown-menu mt-3 be-free" aria-labelledby="nav-dropdown">
            <div className="the-real-dropdown">
              <div className="notifications-list">
                { messages.length === 0
                  ? (
                    <div className="text-center">
                      <div>You don't have any notifications right now</div>
                      <div>Your notifications will appear here after you launch or participate</div>
                    </div>
                  )
                  : (
                    <div>
                    { messages && messages.map((message, idx) => (
                      <Notification key={idx} message={message} />
                      ))
                    }
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        ) }
      </div>
    );
  }
}

const Notification = ({ message }) => {
  const time = moment.unix(message.created_time).fromNow();
  const onClick = () => {
    notificationApi.clear(message.id).then(() => {
      NavigationUtils.routeToLegacy(`/q/${message.event_slug}/answers`);
    });
    
    // created_time: 1613614368
    // event_id: "a617818d-bfd6-4123-9c85-63f237b0ed45"
    // event_slug: "kKA1Gy13"
    // event_title: "What ONE thing can we do everyday to stay connected as a team?"
    // id: "b96e795a-a49b-41ad-75a3-66bb9a34d802"
    // routing: "view_event"
    // style: "vote_yours"
    // subtitle: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
    // target_id: "76fe036b-d074-4aa5-8afc-d1ee33604f47"
    // target_type: "comment"
    // title: "Someone liked your comment"
    // unseen: false
    // updated_time: 1613614368
  }
  return (
    <div className="notif" onClick={onClick}>
      <div className="notif__time">{time}</div>
      <div className="notif__title">{message.title}</div>
      <div className="notif__subtitle">
        {message.subtitle}
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    loggingOut: state.logout.loggingOut,
    messages: []
  };
};

export default connect(mapStateToProps, {})(NotificationsDropdown);
